<!--　レポート詳細：Section1Top内疾病ボタン
  変更履歴：
    2019/06/05
      ・ボタンフォント調整（p）
-->

<template>
    <div class="button-wrapper">
        <!-- ボタン左 -->
        <div class="button button-left" @click="clickLeft">
            <p>◀</p>
        </div>
        <div class="button button-middle">
            <p v-text="diseaseName"/>
        </div>
        <!-- ボタン右 -->
        <div class="button button-right" @click="clickRight">
            <p>▶</p>
        </div>
    </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        diseaseName: VueTypes.string.isRequired
    },
    methods: {
        clickLeft () {
            this.$emit('click-left')
        },
        clickRight () {
            this.$emit('click-right')
        }
    }
}
</script>

<style scoped>
  .button-wrapper {
      display: flex;
      justify-content: center;
  }
  .button {
      background-color: #C5D7EF;
      height: 60px;
  }
  .button > p {
      line-height: 60px;
  }
  .button-middle {
      padding-left: 20px;
      padding-right: 20px;
      width: 60%;
      min-width: 100px;
  }
  .button-middle > p {
      font-family: "HiraKakuPro-W6";
      font-size: 19px;
  }
  .button-left,
  .button-right {
      padding-left: 5px;
      padding-right: 5px;
  }
  .button-left {
      margin-right: 2px;
      border-radius: 5px 0 0 5px;
  }
  .button-right {
      margin-left: 2px;
      border-radius: 0 5px 5px 0;
  }
  .button-left:hover,
  .button-right:hover {
      cursor: pointer;
  }
</style>
